module.exports = __webpack_public_path__ + "static/media/AppIcon.33e1ef0c.svg";